/* eslint-disable */
require('./assassination_alt')
require('./assassination')
require('./colonization_alt')
require('./colonization')
require('./conquest_alt')
require('./conquest')
require('./conversion_alt')
require('./conversion')
require('./encourage_hate_alt')
require('./encourage_hate')
require('./fight_alt')
require('./fight')
require('./frame_action')
require('./infiltrate_alt')
require('./infiltrate')
require('./jump_alt')
require('./jump')
require('./gateway_charge')
require('./gateway_charge_alt')
require('./gateway_jump')
require('./gateway_fatigue')
require('./loot_alt')
require('./loot')
require('./make_dominion_alt')
require('./make_dominion')
require('./raid_alt')
require('./raid')
require('./sabotage_alt')
require('./sabotage')
